import { render } from "./EditReport.vue?vue&type=template&id=8c091b72"
import script from "./EditReport.vue?vue&type=script&lang=js"
export * from "./EditReport.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__